/** Slice registry — each ported reference method contributes its part of the flat model, in the reference spread order
 *  (`...this.exec(), ...this.review(), ...this.eodModel(), ...this.apModel(), ...this.anModel(), ...this.jrnModel(),
 *   ...this.cmpModel(), ...this.dgModel(), ...this.pfModel(), ...this.tiModel(), ...this.aiModel()`). Later wins. */
import type { Ctx } from './ctx';
import type { ViewModel } from '@/screens/generated/view-model';
import { buildExec } from './exec';
import { buildLinking } from './linking';
import { buildInvestors } from './investors';
import { buildRisk } from './risk';
import { buildStrategies } from './strategies';
import { buildWidgets } from './widgets';
import { buildGlobalFilters } from './global-filters';
import { buildReview } from './review';
import { buildEod } from './eod';
import { buildProgress } from './progress';
import { buildCompare } from './compare';
import { buildDigest } from './digest';
import { buildAnalytics } from './analytics';
import { buildJournal } from './journal';
import { buildDashboard } from './dashboard';
import { buildScore } from './score';
import { buildStyle } from './style';
import { buildAi } from './ai';
import { buildCharts } from './charts';
import { buildDay } from './day';
import { buildOverlays } from './overlays';

export function buildSlices(c: Ctx): Partial<ViewModel> {
  return {
    // The shared overlays and the chart bindings first: a screen slice may hand the tooltip or the drawer a spec,
    // and later spreads win.
    ...buildOverlays(c),
    ...buildCharts(c),
    ...buildDay(c),
    ...buildDashboard(c), // the two renderVals IIFEs — spread first, as in the reference
    ...buildExec(c),
    ...buildLinking(c),
    ...buildInvestors(c),
    ...buildRisk(c),
    ...buildStrategies(c),
    ...buildWidgets(c),
    ...buildGlobalFilters(c),
    ...buildReview(c),
    ...buildEod(c),
    ...buildProgress(c),
    ...buildAnalytics(c),
    ...buildJournal(c),
    ...buildCompare(c),
    ...buildDigest(c),
    ...buildScore(c),
    ...buildStyle(c),
    ...buildAi(c),
  };
}
